<template>
  <div>
    <div v-if="showLoader">
      <loader v-if="showLoader"></loader>
      <vue-progress-bar class="progress_bar_header"></vue-progress-bar>
    </div>
    <Modal :show="showCancelModal" :title="widget.translate('ml_are_you_sure', 'Are you sure?')" helpText="" :cancelButton="widget.translate('CANCEL_BUTTON_TITLE', 'Cancel')" :okButton="widget.translate('rsb_discard_results', 'Discard Results')" @modalCallback="modalOkCallback" />
    <div v-if="isThankYouScreen" class="pw-height-100 d-flex flex-column justify-content-center align-items-center p-48">
      <div>
        <div class="text-center learn-study-title" style="font-size: 22px" v-translate:document_sent="lang">
          Document Sent
        </div>
        <p class="pt-11 verify-email-text text-color m-0">
          {{ labelParticipantDocumentSent }}
        </p>
        <div class="text-center pt-24">
          <img src="static/img/participant-portal/tick.png" alt="" class="edu-green-check" />
        </div>
        <div class="text-center vs-document-btn pt-48 pb-38 mt-auto user-info">
          <button class="btn btn-submit secondary-bg" v-translate:pweb_label_done="lang" @click="() => this.$emit('signingCompleted')">
            Done
          </button>
        </div>
      </div>
    </div>
    <SignerDetailsForm v-else-if="signerDetailsFormShow" :role="currentSigningRoleKey" :page="signerDetailsFormPageIndex" @pageChange="evt => (signerDetailsFormPageIndex = evt)" v-model="currentSignerDetails" :requiredFields="requiredFields" @cancelled="signerNotSigning" @change="signerDetailsCompleted" />
    <DocumentDisclamer v-else-if="showParticipantDisclaimer" @disagree="$emit('backButtonClicked')" :newSignedDocs="signs" @onSignDoc="disclaimersCompleted" :disclaimers="getListOfDisclamer" />
    <template v-else>
      <DocumentViewer :documentUrl="currentDocument.configuredDocumentS3Url" :selectedItem="selectedInputItem" :success="selectedSuccess" @loading="stat => (isDocLoading = stat)" />
      <DocumentInputField v-if="selectedInputItem != null" @validated="evt => (validDocInputField = evt)" v-model="docInputFieldValue" :field="selectedInputItem" />
      <div v-if="showCompleteButton" class="text-center vs-document-btn pt-48 pb-38 mt-auto user-info">
        <button class="btn leave_study_cntue primary-bg" v-translate:dashboard_complete_title="lang" @click="completeSigning">
          Complete
        </button>
      </div>
      <div v-else class="text-center vs-document-btn pt-48 pb-38 mt-auto user-info">
        <button class="btn leave_study_cntue primary-bg" :disabled="isDocLoading ? true : selectedInputItem === null ? false : isNextButtonDisabled" @click="onNextClick(false)">
          {{ buttonLabel }}
        </button>
        <button v-if="selectedInputItem !== null && !selectedInputItem.required" class="btn leave_study_cntue primary-bg mt-10" @click="onNextClick(true)">
          {{ DoNotWantButtonLabel }}
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import SignerDetailsForm from "./signer-details-form";
import DocumentInputField from "./document-input-field";
import DocumentViewer from "./document-viewer";
import Modal from "@/components/participant-portal/common/modal";
import DocumentDisclamer from "./disclamer";
import { Widget } from "@/components/services/participant-service";
import moment from "moment";
import _ from "lodash";
import loader from "@/components/common/loader";
export default {
  name: "DocumentSigner",
  components: {
    loader,
    SignerDetailsForm,
    DocumentViewer,
    DocumentInputField,
    DocumentDisclamer,
    Modal
  },
  props: ["document"],
  data() {
    return {
      widget: new Widget(),
      isThankYouScreen: false,
      showCancelModal: false,
      currentDocument: this.document,
      signerRoleInputs: null,
      signerDetailsFormPageIndex: 0,
      signerRoles: [],
      signs: null,
      selectedSuccess: false,
      rolesSigned: [],
      rolesTobeSigned: [],
      currentSigningRoleKey: "",
      selectedInputItemIndex: 0,
      currentSignerDetails: null,
      signerDetailsFormShow: false,
      validDocInputField: false,
      docInputFieldValue: false,
      showParticipantDisclaimer: false,
      disableNext: false,
      payload: null,
      disclaimerDone: false,
      showCompleteButton: false,
      debugSubmit: true,
      showLoader: false,
      isDocLoading: false
    };
  },
  mounted() {
    this.setUp();
    this.$root.$emit("SetCancelButtonVisibility", true);
    this.$root.$emit("SetBackButtonClickEvent", "signerpage-backclicked");
  },
  computed: {
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    hasCurrentRoleSignature() {
      return this.signs === null ? false : this.signs[this.currentSigningRoleKey] !== undefined;
    },
    isNextButtonDisabled() {
      return !this.validDocInputField || this.disableNext;
    },
    selectedInputItem() {
      return this.currentSigningRoleKey === "" ? null : this.signerRoleInputs[this.currentSigningRoleKey] ? this.signerRoleInputs[this.currentSigningRoleKey][this.selectedInputItemIndex] : null;
    },
    requiredFields() {
      return this.currentSigningRoleKey === "" ? null : this.signerRoleInputs[this.currentSigningRoleKey] ? this.signerRoleInputs[this.currentSigningRoleKey].map(item => item.fieldType) : null;
    },
    hasDisclaimers() {
      return this.getListOfDisclamer.length > 0;
    },
    isSignerRemains() {
      return this.rolesTobeSigned.length > 0;
    },
    buttonLabel() {
      if (this.selectedInputItem === null) {
        return this.widget.translate("text_signin_button", "Next");
      } else if (this.selectedInputItem.fieldType === "name") {
        return this.widget.translate("label_name_response_btn", "Add Name and Continue");
      } else if (this.selectedInputItem.fieldType === "initials") {
        return this.widget.translate("label_initials_response_btn", "Add Initials");
      } else if (this.selectedInputItem.fieldType === "signature") {
        return this.widget.translate("label_signature_response_btn", "Add Signature");
      } else if (this.selectedInputItem.fieldType === "checkbox") {
        return this.widget.translate("label_check_mark_response_btn", "Mark As My Response");
      } else if (this.selectedInputItem.fieldType === "text") {
        return this.widget.translate("label_text_response_btn", "Add Text");
      } else {
        return this.widget.translate("text_signin_button", "Next");
      }
    },
    DoNotWantButtonLabel() {
      if (this.selectedInputItem.fieldType === "name") {
        return this.widget.translate("label_name_response_btn_skip", "Do not Add Name");
      } else if (this.selectedInputItem.fieldType === "initials") {
        return this.widget.translate("label_initials_response_btn_skip", "I Do Not Want To Initial");
      } else if (this.selectedInputItem.fieldType === "signature") {
        return this.widget.translate("label_signature_response_btn_skip", "I Do Not Want To Sign");
      } else if (this.selectedInputItem.fieldType === "checkbox") {
        return this.widget.translate("label_check_mark_response_btn_skip", "Do Not Mark As My Response");
      } else if (this.selectedInputItem.fieldType === "text") {
        return this.widget.translate("label_text_response_btn_skip", "I Do Not Want To Add Text");
      }
      return "";
    },
    getCareGiverConfigureList() {
      return this.document && this.document.careGiverConfigureList;
    },
    getObserverConfigureList() {
      return this.document && this.document.observerConfigureList;
    },
    getParticipantConfigureList() {
      return this.document && this.document.participantConfigureList;
    },
    getListOfDisclamer() {
      return this.document && this.document.disclaimerConfigureList;
    },
    signerDetailsFormActive() {
      if (this.currentSigningRoleKey !== "" && !this.hasCurrentRoleSignature) {
        return true;
      } else {
        return false;
      }
    },
    isLastInputOfCurrentRole() {
      if (this.signerRoleInputs && this.signerRoleInputs[this.currentSigningRoleKey]) {
        if (this.selectedInputItemIndex + 1 === this.signerRoleInputs[this.currentSigningRoleKey].length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    labelParticipantDocumentSent() {
      return this.widget.translate("label_participant_document_sent_desc", "Thank you. Your signed document has been sent to the study team.").replace("\\n", " ");
    }
  },
  methods: {
    setUp() {
      this.$root.$on("signerpage-backclicked", evt => {
        this.backButtonHandler(evt);
      });
      this.$root.$on("profilepage-cancelclicked", evt => {
        this.cancelButtonHandler(evt);
      });
      let list = [];
      this.payload = Object.assign({}, this.document);
      if (this.getParticipantConfigureList && this.getParticipantConfigureList.length > 0) {
        list = [...list, ...this.getParticipantConfigureList];
      }
      if (this.getCareGiverConfigureList && this.getCareGiverConfigureList.length > 0) {
        list = [...list, ...this.getCareGiverConfigureList];
      }
      if (this.getObserverConfigureList && this.getObserverConfigureList.length > 0) {
        list = [...list, ...this.getObserverConfigureList];
      }
      list.map(item => {
        if (this.signerRoleInputs === null) {
          this.signerRoleInputs = {};
        }
        if (this.signerRoleInputs[item.role + item.roleOrder] == undefined) {
          this.signerRoleInputs[item.role + item.roleOrder] = [];
          this.signerRoles.push(item.role + item.roleOrder);
          this.rolesTobeSigned.push(item.role + item.roleOrder);
        }
        this.signerRoleInputs[item.role + item.roleOrder].push(item);
      });
      this.disclaimerDone = false;
    },
    modalOkCallback() {
      this.$emit("backButtonClicked");
    },
    backButtonHandler() {
      if (this.currentSigningRoleKey == "") {
        this.$emit("backButtonClicked");
      }
      if (this.signerDetailsFormShow) {
        if (this.signerDetailsFormPageIndex === 0 || (this.signerDetailsFormPageIndex === 1 && this.currentSigningRoleKey.includes("participant"))) {
          this.rolesTobeSigned.unshift(this.currentSigningRoleKey);
          if (this.rolesSigned.length !== 0) {
            this.currentSigningRoleKey = this.rolesSigned.pop();
            this.currentSignerDetails = this.signs[this.currentSigningRoleKey];
            this.selectedInputItemIndex = this.signerRoleInputs[this.currentSigningRoleKey].length - 1;
            if (this.hasDisclaimers) {
              this.showParticipantDisclaimer = true;
            }
          } else {
            this.currentSigningRoleKey = "";
          }
          this.signerDetailsFormShow = false;
        } else {
          let newPage = this.signerDetailsFormPageIndex - 1;
          if (!this.requiredFields.includes("initials") && newPage === 2) {
            newPage = 1;
          }
          this.signerDetailsFormPageIndex = newPage;
        }
      } else if (this.selectedInputItem !== null) {
        if (this.selectedInputItemIndex === 0) {
          this.currentSignerDetails = this.signs[this.currentSigningRoleKey];
          delete this.signs[this.currentSigningRoleKey];
          this.selectedInputItemIndex = 0;
          this.signerDetailsFormShow = true;
          this.disableNext = false;
        } else {
          this.selectedInputItemIndex = this.selectedInputItemIndex - 1;
          const newItem = this.signs[this.currentSigningRoleKey].responseList.find(item => item.id === this.selectedInputItem.id);
          this.docInputFieldValue = newItem.responseText;
          const index = this.signs[this.currentSigningRoleKey].responseList.indexOf(this.selectedInputItem);
          this.signs[this.currentSigningRoleKey].responseList.splice(index, 1);
          this.disableNext = false;
        }
      } else if (this.showParticipantDisclaimer) {
        this.signs["consentDisclaimer"] = [];
        this.showParticipantDisclaimer = false;
      }
    },
    cancelButtonHandler() {
      this.showCancelModal = true;
    },
    disclaimersCompleted(data) {
      this.disclaimerDone = true;
      this.signs["consentDisclaimer"] = data;
      this.showParticipantDisclaimer = false;
      this.onNextClick(false);
    },
    signerNotSigning() {
      this.rolesSigned.push(this.currentSigningRoleKey);
      if (!this.isSignerRemains) {
        this.currentSigningRoleKey = "";
        this.signerDetailsFormShow = false;
        this.showCompleteButton = true;
      } else {
        this.currentSigningRoleKey = this.rolesTobeSigned.shift();
      }
    },
    onNextClick(isSkip) {
      if (this.currentSigningRoleKey !== "") {
        this.updateSignsData(isSkip);
      }

      if (!this.isSignerRemains && this.isLastInputOfCurrentRole) {
        this.showCompleteButton = true;
      }
      if (this.currentSigningRoleKey === "" || (this.currentSigningRoleKey !== "" && this.isLastInputOfCurrentRole)) {
        if (this.currentSigningRoleKey.includes("participant") && !this.disclaimerDone && this.hasDisclaimers) {
          this.showParticipantDisclaimer = true;
          this.signs.consentDisclaimer = [];
        } else if (this.currentSigningRoleKey === "") {
          this.getSignFromNextSigner();
        } else {
          this.selectedSuccess = true;
          this.disableNext = true;
          setTimeout(() => {
            this.getSignFromNextSigner();
          }, 2000);
        }
      } else {
        this.selectedSuccess = true;
        this.disableNext = true;
        setTimeout(() => {
          this.selectedInputItemIndex = this.selectedInputItemIndex + 1;
          this.selectedSuccess = false;
          this.validDocInputField = false;
          this.disableNext = false;
        }, 2000);
      }
    },
    updateSignsData(isSkip) {
      if (this.signs[this.currentSigningRoleKey].responseList === undefined) {
        this.signs[this.currentSigningRoleKey].responseList = [];
      }
      this.signs[this.currentSigningRoleKey] = {
        ...this.signs[this.currentSigningRoleKey],
        ...this.currentSignerDetails
      };
      this.formatPayloadData(isSkip);
      if (this.selectedInputItem.fieldType === "name") {
        this.selectedInputItem.responseText = this.currentSignerDetails.firstName + " " + this.currentSignerDetails.lastName;
      }
      this.signs[this.currentSigningRoleKey].responseList.push(this.selectedInputItem);
    },
    formatPayloadData(isSkip) {
      const now = new Date();
      this.selectedInputItem["isSkip"] = isSkip;
      this.selectedInputItem["responseAtLocal"] = moment(now).format("YYYY-MM-DD HH:mm:ss");
      this.selectedInputItem["responseAtLocalOffset"] = moment(now).format("Z");
      this.selectedInputItem["responseAtUtc"] = moment.utc(now).format("YYYY-MM-DD HH:mm:ss");
      this.selectedInputItem["responseByRole"] = this.currentSigningRoleKey.substring(0, this.currentSigningRoleKey.length - 1);
      this.selectedInputItem["responseText"] = this.docInputFieldValue;
    },
    getSignFromNextSigner() {
      if (this.currentSigningRoleKey !== "") {
        this.rolesSigned.push(this.currentSigningRoleKey);
      }
      this.currentSigningRoleKey = this.rolesTobeSigned.shift();
      this.selectedSuccess = false;
      this.selectedInputItemIndex = 0;
      this.currentSignerDetails = null;
      this.signerDetailsFormPageIndex = 0;
      if (this.currentSigningRoleKey != null) {
        this.signerDetailsFormShow = true;
      }
    },
    signerDetailsCompleted(data) {
      if (this.signs === null) {
        this.signs = {};
      }
      this.signs[this.currentSigningRoleKey] = data;
      this.selectedInputItemIndex = 0;
      this.signerDetailsFormShow = false;
      this.disableNext = false;
    },
    completeSigning() {
      this.showLoader = false;
      const payload = {
        participantId: this.currentDocument.participantId,
        docId: this.currentDocument.docId,
        docName: this.currentDocument.docName,
        consentDisclaimer: [],
        careGiverConfiguredDocList: [],
        observerConfiguredDocList: [],
        participantConfiguredDoc: {}
      };

      for (const key in this.signs) {
        if (key.includes("participant")) {
          payload.participantConfiguredDoc = this.signs[key];
        }
        if (key.includes("consentDisclaimer")) {
          _.map(this.signs.consentDisclaimer, signtab => {
            delete signtab.value;
          });
          payload.consentDisclaimer = this.signs.consentDisclaimer;
        }
        if (key.includes("caregiver")) {
          payload.careGiverConfiguredDocList.push(this.signs[key]);
        }
        if (key.includes("observer")) {
          payload.observerConfiguredDocList.push(this.signs[key]);
        }
      }
      payload.consentDisclaimer = this.signs.consentDisclaimer ? this.signs.consentDisclaimer : [];
      this.$api
        .saveDocumentAndSignature(this.currentDocument.participantId, this.currentDocument.studyId, payload)
        .then(() => {
          this.$root.$emit("SetCancelButtonVisibility", false);
          this.showLoader = false;
          this.isThankYouScreen = true;
        })
        .catch(error => {
          this.showLoader = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving configured document signature.");
        });
    }
  }
};
</script>
